// Two functions to highly improve usability if the map for iOS devices
let lastTouchEnd = 0;
let iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
// only applies if the device is an iOS device and the page is the homepage.
if (iOS && window.location.pathname === '/') {
  document.addEventListener('touchend', function (event) {
    var now = (new Date()).getTime();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  }, false);

  document.addEventListener('touchmove', function (event) {
    if (event.scale !== 1) { event.preventDefault(); }
  }, false);
}



// WEBPACK FOOTER //
// ./src/helpers/disableTouchScroll.js